import {KumaViewDto, MenuDto} from "../../services/Client";
import {AnyAction} from "redux";
import {ActionTypes} from "./ActionTypes";

const KumaViewActions = {
    ReceiveKumaExtraLinksAction(dto: MenuDto): AnyAction {
        return {type: ActionTypes.RECEIVE_KUMA_EXTRA_LINKS, kumaExtraLinks: dto};
    },
    ReceivedKumaRequirementsAction(requirements:KumaViewDto[]):AnyAction {
        return {type: ActionTypes.RECEIVED_KUMA_REQUIREMENTS, requirements: requirements};
    }
};

export default KumaViewActions;



// WEBPACK FOOTER //
// ./src/redux/actions/KumaViewActions.tsx